import { StudentType } from '@chegg/one-auth-sdk';
export default function validateSignup(state, options) {
  var _options$form, _ref4, _ref4$highschool, _ref5, _ref5$college, _ref6, _ref6$college, _ref6$college$college;
  var credentials = state.credentials,
    showUserInfo = state.showUserInfo,
    userInfo = state.userInfo,
    isSso = state.isSso;
  var student = userInfo.student,
    selectedUserType = userInfo.userType;
  var selctedStudentType = student.studentType;

  // check credentials
  if (!isSso) {
    if (!credentials.email.valid || credentials.email.error) {
      return false;
    }
    if (!credentials.password.valid || credentials.password.error) {
      return false;
    }
  }

  // check userinfo if form configured with such
  if (showUserInfo && options !== null && options !== void 0 && (_options$form = options.form) !== null && _options$form !== void 0 && _options$form.userInfo) {
    var _ref, _ref2, _ref3;
    var form = options.form;
    if (form.userInfo && !selectedUserType) {
      // check identity
      return false;
    }

    /* if form is configured to select a studentType but no value in state.studentType */
    if (((_ref = form.userInfo[selectedUserType]) !== null && _ref !== void 0 && _ref.highschool || (_ref2 = form.userInfo[selectedUserType]) !== null && _ref2 !== void 0 && _ref2.college || (_ref3 = form.userInfo[selectedUserType]) !== null && _ref3 !== void 0 && _ref3.middleschool) && !selctedStudentType) {
      return false;
    }
    switch (selctedStudentType) {
      case StudentType.highschool:
        if ((_ref4 = form.userInfo[selectedUserType]) !== null && _ref4 !== void 0 && (_ref4$highschool = _ref4.highschool) !== null && _ref4$highschool !== void 0 && _ref4$highschool.highschoolGradYearSelect && !student.highschool.hsGradYear) {
          return false;
        }
        break;
      case StudentType.college:
        if ((_ref5 = form.userInfo[selectedUserType]) !== null && _ref5 !== void 0 && (_ref5$college = _ref5.college) !== null && _ref5$college !== void 0 && _ref5$college.collegeSelect && !student.college.campusId) {
          return false;
        }
        if ((_ref6 = form.userInfo[selectedUserType]) !== null && _ref6 !== void 0 && (_ref6$college = _ref6.college) !== null && _ref6$college !== void 0 && (_ref6$college$college = _ref6$college.collegeSelect) !== null && _ref6$college$college !== void 0 && _ref6$college$college.yearInSchool && !student.college.yearInCollege) {
          return false;
        }
        break;
    }
  }
  return true;
}